<template>
  <div id="menber_point" class="menber_control menber_nav padding-30">
    <div class="h_title m-b-15">
      <ul>
        <li class="order_cate_0 active_bg">
          <a href="javascript:;" :style="'color:' + $store.state.color ">
            我的积分
            <em :style="'background:' + $store.state.color"></em>
          </a>
        </li>
      </ul>
    </div>
    <div class="b_cont member_table">
      <div class="order_list order_0 active_bg">
        拥有积分：{{info.data.point || 0}}分 
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['info'])
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/pages/Point.vue